import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import OperatorAdminSimple from "./OperatorAdminSimple";
import GuestDashboard from "./GuestDashboard";

const UserDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    navigate("/login");
    return null;
  }

  if (user.role === "operator") {
    return <OperatorAdminSimple />;
  }

  if (user.role === "guest") {
    return <GuestDashboard />;
  }

  // Optionally handle other roles or show a default message
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-xl text-red-500 font-bold">You do not have permission to view this dashboard.</div>
    </div>
  );
};

export default UserDashboard; 